export const isMobile = () => window.innerWidth < 768;

export const getBrandLogoUrl = (theme) => {
    if(theme==='dark')
        return "https://res.cloudinary.com/urbanclap/image/upload/images/growth/home-screen/1631097450980-d2de38.png";
    if(theme==='white')
        return "https://res.cloudinary.com/urbanclap/image/upload/t_high_res_category/images/supply/partner-training/1628575858610-5b0ae4.png";
}